import {FreeTrialProgram, relevantFreePickupSoccerAndLeaguesUrlParams} from '@/common/fko-utils';
import {
  getFreePickupAndLeaguesFormDataForSubmission,
  getFreePickupAndLeaguesFormFields,
} from '@/common/freePickupandLeaguesUtils';
import CommonRegistrationPage from '@/components/Forms/CommonRegistrationForm/CommonRegistrationPage';
import {tocaLocations, tocaLocationsWithoutWorkingMboSiteId} from '@/constants/locations';
import {memo} from 'react';

const locationsAllowed = [...tocaLocations, ...tocaLocationsWithoutWorkingMboSiteId]
  .filter((loc) => loc.leaguesSupported)
  .map((loc) => loc.hubspotName);

const FreeLeaguesRegistrationPage = memo(() => {
  return (
    <CommonRegistrationPage
      programName={FreeTrialProgram.LEAGUES_TRIAL}
      locationsAllowed={locationsAllowed}
      formId={import.meta.env.VITE_HUBSPOT_FREE_LEAGUES_FORM_ID ?? ''}
      relevantUrlParams={relevantFreePickupSoccerAndLeaguesUrlParams}
      getFormFields={getFreePickupAndLeaguesFormFields}
      getHubspotFormDataForSubmission={getFreePickupAndLeaguesFormDataForSubmission}
    />
  );
});

FreeLeaguesRegistrationPage.displayName = 'FreeLeaguesRegistrationPage';

export default FreeLeaguesRegistrationPage;
